module.exports = __webpack_public_path__ + "img/logo-white.f5b1043b.png";